import * as service from './services'
import { to } from 'await-to-js'

export const state = {
  formBusca: {
    tipoPedido: 'Consulta',
    especialidade: null,
    exame: null,
    cidade: null,
    rate: 0,
    servicoAgendamento: null,
    servicoDelivery: null,
    nomeRede: null,
    valorInicial: null,
    valorFinal: null,
    ordenacao: null
  },

  result: []
}

export const getters = {
  formBusca: state => state.formBusca,
  result: state => state.result
}

export const mutations = {
  setFormBusca (state, payload) {
    state.formBusca = payload
  },

  setResult (state, payload) {
    state.result = payload
  },

  setEnderecoFormatado (state, payload) {
    state.enderecoFormatado = payload
  }
}

function buildFiltro (getters, formFiltro) {
  let filtro = Object.assign({}, formFiltro)
  filtro.status = 'HABILITADO'
  if (formFiltro.rate === 0) {
    delete filtro.rate
  }

  if (getters.cidade) {
    filtro.cidade = makeslug(getters.cidade)
  }

  if (getters.bairro) {
    filtro.bairro = makeslug(getters.bairro)
  }

  if (getters.uf) {
    filtro.uf = makeslug(getters.uf)
  }

  if (formFiltro.especialidade) {
    filtro.especialidade = formFiltro.especialidade._id
  }

  if (formFiltro.exame) {
    filtro.exame = formFiltro.exame.codigoExame
  }

  if (!formFiltro.servicoAgendamento) {
    delete filtro.agendamento
    delete filtro.servicoAgendamento
  } else if (formFiltro.servicoAgendamento) {
    filtro.agendamento = true
    delete filtro.servicoAgendamento
  }

  if (!formFiltro.servicoDelivery) {
    delete filtro.servicoDelivery
  }

  if (!formFiltro.pagamentoOnline) {
    delete filtro.pagamentoOnline
  }

  if (!formFiltro.pagamentoAto) {
    delete filtro.pagamentoAto
  }

  if (!formFiltro.coletaDomicilio) {
    delete filtro.servicoDelivery
    delete filtro.coletaDomicilio
  } else if (formFiltro.coletaDomicilio) {
    filtro.servicoDelivery = true
    delete filtro.coletaDomicilio
  }

  if (formFiltro.ordenacao) {
    switch (formFiltro.ordenacao) {
      case 'Preco':
        filtro.sort = formFiltro.tipoPedido === 'Consulta' ? 'consultas.valorSinSaude' : 'exames.valorSinSaude'
        filtro.order = 'asc'
        break
      case 'MaiorPreco':
        filtro.sort = formFiltro.tipoPedido === 'Consulta' ? 'consultas.valorSinSaude' : 'exames.valorSinSaude'
        filtro.order = 'desc'
        break
      case 'Prestador':
        filtro.sort = 'nomeRede'
        filtro.order = 'asc'
        break
      case 'MelhorAvaliacao':
        filtro.sort = 'rate'
        filtro.order = 'desc'
        break
    }
  } else {
    delete filtro.sort
    delete filtro.order
  }

  return filtro
}

function makeslug (val, replaceBy) {
  replaceBy = replaceBy || '-'
  let mapaAcentosHex = { // by @marioluan and @lelotnk
    a: /[\xE0-\xE6]/g,
    A: /[\xC0-\xC6]/g,
    e: /[\xE8-\xEB]/g, // if you're gonna echo this
    E: /[\xC8-\xCB]/g, // JS code through PHP, do
    i: /[\xEC-\xEF]/g, // not forget to escape these
    I: /[\xCC-\xCF]/g, // backslashes (\), by repeating
    o: /[\xF2-\xF6]/g, // them (\\)
    O: /[\xD2-\xD6]/g,
    u: /[\xF9-\xFC]/g,
    U: /[\xD9-\xDC]/g,
    c: /\xE7/g,
    C: /\xC7/g,
    n: /\xF1/g,
    N: /\xD1/g
  }
  for (var letra in mapaAcentosHex) {
    let expressaoRegular = mapaAcentosHex[letra]
    val = val.replace(expressaoRegular, letra)
  }

  return val
}

export const actions = {
  setFormBusca ({ commit }, payload) {
    commit('setFormBusca', payload)
  },
  setResult ({ commit }, payload) {
    commit('setResult', payload)
  },
  async busca ({ getters, dispatch }) {
    dispatch('setLoading', true)
    let filtro = buildFiltro(getters, getters.formBusca)

    if (filtro.tipoPedido === 'Consulta') {
      if (!filtro.especialidade) {
        dispatch('setResult', [])
        dispatch('setLoading', false)
        return false
      }
      if (getters.user && getters.user.cartao) {
        filtro.cartao = getters.user.cartao.numeroCartao
      }
      if (!filtro.cidade || !filtro.uf) {
        dispatch('setResult', [])
        dispatch('setLoading', false)
        return false
      }
      const [error, response = {data: []}] = await to(service.busca(filtro))
      if (error) {
        console.log(error)
        dispatch('showErrorMsg', error)
        dispatch('setResult', [])
        return Promise.reject(error.response.data)
      }

      dispatch('setLoading', false)
      dispatch('setResult', response.data)
      return response.data
    } else if (filtro.tipoPedido === 'Exame') {
      if (!filtro.exame) {
        dispatch('setResult', [])
        dispatch('setLoading', false)
        return false
      }
      if (!filtro.cidade || !filtro.uf) {
        dispatch('setResult', [])
        dispatch('setLoading', false)
        return false
      }
      if (getters.user && getters.user.cartao) {
        filtro.cartao = getters.user.cartao.numeroCartao
      }
      const [error, response = {data: []}] = await to(service.buscaExame(filtro))
      if (error) {
        console.log(error)
        dispatch('showErrorMsg', error)
        dispatch('setResult', [])
        return Promise.reject(error.response.data)
      }

      let resultBusca = response.data

      if (resultBusca.data) {
        resultBusca.data = resultBusca.data.filter(rede => rede.status !== 'PRE_CADASTRO')
      }

      dispatch('setLoading', false)
      dispatch('setResult', resultBusca)
      return resultBusca
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/formBusca/index.js